import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import DealerDropdownBySap from '../../../../../components/common/DealerDropdownBySap';
import DealerDropdown from '../../../../../components/common/DealerDropdown';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import AddressBrandBlocks from './AddressBrandBlocks';

/**
 * Birleşik bayi kaydı formu (bayi + N adres+marka bloğu).
 * readOnly=true iken (Pending/kilit) tüm alanlar salt-okunur; radio ile blok seçimi açık kalır.
 * changedFields: bayi seviyesi staged alan adları.
 */
const DealerRegistrationForm = (props) => {
    const { th } = useLanguage();
    const {
        readOnly = false,
        isNew = false,
        changedFields = [],
        submitted,
        selectedDealer,
        onDealerChange,
        sapDealerId,
        erpDealerInteger,
        fullName,
        showPrice,
        setShowPrice,
        showDiscount,
        setShowDiscount,
        showInvoices,
        setShowInvoices,
        canUseFullService,
        setCanUseFullService,
        dealerIsActive,
        setDealerIsActive,
        addresses,
        selectedBlockKey,
        setSelectedBlockKey,
        addBlock,
        removeBlock,
        setBlockField,
        onBlockAddressChange,
        onBlockContractStartDateChange
    } = props;

    const inv = (cond) => (submitted && cond ? 'p-invalid' : '');
    const isPending = (key) => Array.isArray(changedFields) && changedFields.includes(key);
    const pendingBadge = (key) => (isPending(key) ? <Tag className="ml-2" severity="warning" icon="pi pi-exclamation-circle" value={th('dealerApproval.updatedBadge')} /> : null);

    return (
        <div className="p-fluid">
            <Divider align="left">
                <span className="font-bold">{th('dealerRegistration.form.dealerInfo')}</span>
            </Divider>
            <div className="grid">
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">{th('dealerRegistration.field.sapDealerId')}</label>
                    {isNew ? <DealerDropdownBySap value={selectedDealer} initialSearchText={sapDealerId} onChange={onDealerChange} className={inv(!sapDealerId)} /> : <DealerDropdown value={selectedDealer} disabled />}
                    {submitted && !sapDealerId && <small className="p-error">{th('common.requiredField')}</small>}
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.erpDealerInteger')} {pendingBadge('erpDealerInteger')}
                    </label>
                    <InputText value={erpDealerInteger} disabled />
                </div>
                <div className="field col-12 md:col-6">
                    <label className="font-bold block mb-2">
                        {th('dealerRegistration.field.fullName')} {pendingBadge('fullName')}
                    </label>
                    <InputText value={fullName} disabled />
                </div>
                <div className="col-12 flex flex-wrap gap-4">
                    <div className="field-checkbox">
                        <Checkbox inputId="showPrice" checked={!!showPrice} disabled={readOnly} onChange={(e) => setShowPrice(e.checked)} />
                        <label htmlFor="showPrice" className="ml-2">
                            {th('dealerRegistration.field.showPrice')} {pendingBadge('showPrice')}
                        </label>
                    </div>
                    <div className="field-checkbox">
                        <Checkbox inputId="showDiscount" checked={!!showDiscount} disabled={readOnly} onChange={(e) => setShowDiscount(e.checked)} />
                        <label htmlFor="showDiscount" className="ml-2">
                            {th('dealerRegistration.field.showDiscount')} {pendingBadge('showDiscount')}
                        </label>
                    </div>
                    <div className="field-checkbox">
                        <Checkbox inputId="showInvoices" checked={!!showInvoices} disabled={readOnly} onChange={(e) => setShowInvoices(e.checked)} />
                        <label htmlFor="showInvoices" className="ml-2">
                            {th('dealerRegistration.field.showInvoices')} {pendingBadge('showInvoices')}
                        </label>
                    </div>
                    <div className="field-checkbox">
                        <Checkbox inputId="canUseFullService" checked={!!canUseFullService} disabled={readOnly} onChange={(e) => setCanUseFullService(e.checked)} />
                        <label htmlFor="canUseFullService" className="ml-2">
                            {th('dealerRegistration.field.canUseFullService')} {pendingBadge('canUseFullService')}
                        </label>
                    </div>
                    <div className="field-checkbox">
                        <Checkbox inputId="dealerIsActive" checked={!!dealerIsActive} disabled={readOnly} onChange={(e) => setDealerIsActive(e.checked)} />
                        <label htmlFor="dealerIsActive" className="ml-2">
                            {th('dealerRegistration.field.isActive')} {pendingBadge('dealerIsActive')}
                        </label>
                    </div>
                </div>
            </div>

            <AddressBrandBlocks
                addresses={addresses}
                selectedBlockKey={selectedBlockKey}
                setSelectedBlockKey={setSelectedBlockKey}
                addBlock={addBlock}
                removeBlock={removeBlock}
                setBlockField={setBlockField}
                onBlockAddressChange={onBlockAddressChange}
                onBlockContractStartDateChange={onBlockContractStartDateChange}
                sapDealerId={sapDealerId}
                submitted={submitted}
                readOnly={readOnly}
            />
        </div>
    );
};

export default DealerRegistrationForm;
